import { TextField, Typography } from '@mui/material';
import { useBankReconciliationContext } from 'contexts/BankReconciliationContext';
import { Controller, useFormContext } from 'react-hook-form';
import { FormValues } from '..';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import BasicSelect from 'further-ui/components/BasicSelect';
import { Row, Column } from 'further-ui/components/Layout';

const CreateTransfer: React.FC = () => {
  const { control } = useFormContext<FormValues>();
  const { selectedBankAccount, bankAccounts } = useBankReconciliationContext();

  const { vehicle } = useVehicle(selectedBankAccount?.vehicleId);

  const bankAccountOptions = bankAccounts
    .filter(
      (bankAccount) =>
        bankAccount.id !== selectedBankAccount?.id &&
        (selectedBankAccount?.accountCurrency === vehicle?.baseCurrency ||
          bankAccount.accountCurrency === vehicle?.baseCurrency),
    )
    .map((bankAccount) => ({
      label: bankAccount.accountName,
      value: bankAccount.id,
    }));

  return (
    <Row fullWidth spacing="lg" breakpoint="sm">
      <Column spacing="sm" fullWidth>
        <Typography variant="h6" color="grey.700">
          Select transfer bank account
        </Typography>
        <Controller
          control={control}
          name="targetBankAccountId"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <BasicSelect
              options={bankAccountOptions}
              value={value}
              onChange={onChange}
              placeholder="Select bank account"
              fullWidth
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Column>
      <Column spacing="sm" fullWidth>
        <Typography variant="h6" color="grey.700">
          Enter reference (optional){' '}
        </Typography>

        <Controller
          control={control}
          name="reference"
          render={({ field }) => (
            <TextField size="small" variant="outlined" fullWidth {...field} />
          )}
        />
      </Column>
    </Row>
  );
};

export default CreateTransfer;
